export const tokens = {
  colors: {
    surface: '#ffffff',
    border: '#eaeaea',
    headerBg: '#fafafa',
    cellBorder: '#f0f0f0',
    textMuted: '#616161',
    textSecondary: '#455a64',
    primary: '#1976d2',
    success: '#006400',
    shadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  radius: {
    sm: 2,
    md: 3
  },
  spacing: {
    cardMargin: '12px 16px'
  },
  sizes: {
    tableHeight: 480,
    smallTableHeight: 160,
    mediumTableHeight: 420
  }
}

export default tokens;


